// eslint-disable-next-line
import { ls } from "@/utils/cache.js";
import my from "./modules/my";
import member from "./modules/member";
// import calendarRoom from "./modules/calendarRoom";
import order from "./modules/order";
import calendarRoom from "./modules/room";
import userManage from "./modules/user";
import restaurant from "./modules/restaurant";
import restarantManage from "./modules/restarant_manage";
import roomService from "./modules/room_service";
import report from "./modules/report";

import groupIndex from "./modules/group_index";
import groupOrder from "./modules/group_order";
import groupRoom from "./modules/group_room";
// import groupShop from "./modules/group_shop";
// import groupUser from "./modules/group_user";

const Maps = [
  {
    path: "/workplace",
    name: "workplace",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/workplace/Index.vue"),
    meta: {
      title: "工作台",
      icon: "wap-home-o",
      showNavBar: true,
    },
  },
  {
    path: "/workplace/OrderList",
    name: "todayOrderList",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/workplace/OrderList.vue"),
    meta: {
      title: "今日订单统计",
      showNavBar: false,
    },
  },
  {
    path: "/workplace/registerInVirtul",
    name: "RegisterInVirtul",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/RegisterInVirtul.vue"),
    meta: {
      title: "注册序列号",
      showNavBar: false,
    },
  },
  {
    path: "/workplace/Business",
    name: "Business",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/workplace/Business.vue"),
    meta: {
      title: "运营统计",
      icon: "wap-home-o",
      showNavBar: false,
    },
  },
  {
    path: "/message",
    name: "message",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/Message.vue"),
    meta: {
      title: "消息",
      icon: "chat-o",
      showNavBar: true,
    },
  },
  {
    path: "/Blank",
    name: "blank",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/Blank.vue"),
    meta: {
      title: "",
      showNavBar: false,
    },
  },
];
const modulesMap = Maps.concat(
  my,
  member,
  calendarRoom,
  order,
  userManage,
  groupIndex,
  groupOrder,
  groupRoom,
  restaurant,
  restarantManage,
  roomService,
  report,
  // groupMember,
  // groupShop,
  // groupUser
);

// export const RouterMap = modulesMap;

export const asyncRoutes = [
  {
    path: "/",
    name: "index",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/layouts/BasicLayout.vue"),
    meta: { title: "首页" },
    redirect: "/workplace",
    children: modulesMap,
  },
];

export const constantRoutes = [
  {
    path: "/login",
    name: "login",
    meta: { title: "登录", show: false },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/Login.vue"),
  },
  {
    path: "/WeChatAuthor",
    name: "WeChatAuthor",
    meta: { title: "扫码登录", show: false },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/WeChatAuthor.vue"),
  },
  {
    path: "/BindWeChat",
    name: "BindWeChat",
    meta: { title: "微信绑定", show: false },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/BindWeChat.vue"),
  },
  {
    path: "/WeChatVerifyLoginAdmin",
    name: "WeChatVerifyLoginAdmin",
    meta: { title: "管理员授权登录", show: false },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/WeChatVerifyLoginAdmin.vue"),
  },
  {
    path: "/sign/AccountBill",
    name: "signAccountBill",
    component: () => import("@/views/sign/AccountBill.vue"),
    meta: {
      title: "账单详情",
      show: false,
    },
  },
  {
    path: "/sign/RegisterBill",
    name: "signRegisterBill",
    component: () => import("@/views/sign/RegisterBill.vue"),
    meta: {
      title: "入住登记单详情",
      show: false,
    },
  },
  {
    path: "/sign/SignPanel",
    name: "signPanel",
    component: () => import("@/views/sign/SignPanel.vue"),
    meta: {
      title: "签名面板",
      show: false,
    },
  },
];
